import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Link } from "react-router-dom";
import Form from "react-bootstrap/Form";
import Select from "react-select";
import Button from "react-bootstrap/Button";
import "react-datepicker/dist/react-datepicker.css";
import DownloadExcel from "utils/DownloadExcel";
import { getEmpFullNameTHByEmpData, pageSizeOptions } from "utils/HelperFunction";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import moment from "moment";
import { NumericFormat } from "react-number-format";
import { isShowBranch } from "utils/HelperMemberFunction";
import useInitPesDataList from "hooks/pes/useInitPesDataList";
import PesDocStatus from "layouts/PesDocStatus";
import DocStatus from "layouts/DocStatus";
import { isDoOverDue } from "utils/HelperDoFunction";
export function PesDatalist() {
    var _useInitPesDataList = useInitPesDataList({
        initStatus: null
    }), pageModel = _useInitPesDataList.pageModel, setPageModel = _useInitPesDataList.setPageModel, filterText = _useInitPesDataList.filterText, setFilterText = _useInitPesDataList.setFilterText, data = _useInitPesDataList.data, setData = _useInitPesDataList.setData, btnempstatus = _useInitPesDataList.btnempstatus, setBtnempstatus = _useInitPesDataList.setBtnempstatus, getData = _useInitPesDataList.getData, isMemoLoading = _useInitPesDataList.isMemoLoading, pesStatusCount = _useInitPesDataList.pesStatusCount;
    var columnsd = [
        {
            field: "doc_number",
            headerName: "เลขที่",
            width: 160,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("a", {
                    className: "tc-9",
                    href: "/financial-accounting/peak-connection/pes/edit/".concat(row.id),
                    target: "_blank",
                    children: row.doc_number
                });
            }
        },
        {
            field: "lastest_sync_at",
            headerName: "วันที่ส่ง",
            width: 160,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("div", {
                    children: row.lastest_sync_at ? moment(row.lastest_sync_at).format("DD/MM/YYYY HH:mm:ss") : "-"
                });
            }
        },
        {
            field: "expenseType",
            headerName: "เอกสาร",
            width: 250,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("div", {
                    children: "บันทึกซื้อสินค้า"
                });
            }
        },
        {
            field: "updated_success_at",
            headerName: "วันที่ส่งสำเร็จ",
            width: 160,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("div", {
                    children: row.updated_success_at ? moment(row.updated_success_at).utc().add(7, "hours").format("DD/MM/YYYY HH:mm:ss") : "-"
                });
            }
        },
        {
            field: "grand_total_price",
            headerName: "มูลค่าสุทธิ",
            width: 150,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx(NumericFormat, {
                    displayType: "text",
                    thousandSeparator: ",",
                    decimalScale: 2,
                    fixedDecimalScale: true,
                    value: row.grand_total_price
                });
            }
        },
        {
            field: "count_doc_item",
            headerName: "จำนวนเอกสาร",
            width: 150,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx(NumericFormat, {
                    displayType: "text",
                    thousandSeparator: ",",
                    fixedDecimalScale: true,
                    value: row.count_doc_item
                });
            }
        },
        {
            field: "latest_sync_by_emp_id",
            headerName: "ผู้ส่งเอกสาร",
            width: 150,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                var empFullName = row.latest_sync_by_emp_id ? getEmpFullNameTHByEmpData(row.lastestSyncEmp) : "-";
                return /*#__PURE__*/ _jsx("div", {
                    children: empFullName
                });
            }
        },
        {
            field: "dim_mst_pes_status_id",
            headerName: "สถานะ",
            width: 180,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                var statusID = row.dim_mst_pes_status_id;
                var statusName = row.dimMstPesStatus.name;
                return /*#__PURE__*/ _jsx("div", {
                    className: "flex items-center flex-col",
                    children: /*#__PURE__*/ _jsx(PesDocStatus, {
                        statusID: statusID,
                        statusName: statusName
                    }, "pesstatus-".concat(row.id))
                });
            }
        }
    ];
    return /*#__PURE__*/ _jsxs("div", {
        className: "pes-page",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "pagezoom",
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-2 mb-4",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-16 ps-0",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item ",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "การเงินและบัญชี"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item ",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "เชื่อมต่อ PEAK"
                                    })
                                }),
                                /*#__PURE__*/ _jsxs("li", {
                                    className: "breadcrumb-item active tc-2 ",
                                    "aria-current": "page",
                                    children: [
                                        " ",
                                        "บันทึกซื้อสินค้า",
                                        " "
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "fs-24 mb-4 fw-bold tc-2",
                        style: {
                            color: "rgba(76, 78, 100, 0.87)"
                        },
                        children: "บันทึกซื้อสินค้า"
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "mb-3",
                        children: [
                            /*#__PURE__*/ _jsxs(Button, {
                                type: "button",
                                className: btnempstatus == null ? "btn-category px-4 active" : "btn-category px-4",
                                onClick: function() {
                                    setBtnempstatus(null);
                                },
                                children: [
                                    "ทั้งหมด",
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Button, {
                                type: "button",
                                className: btnempstatus == 1 ? "btn-category px-4 active" : "btn-category px-4",
                                onClick: function() {
                                    setBtnempstatus(1);
                                },
                                children: [
                                    "แบบร่าง(",
                                    pesStatusCount["1"],
                                    ")"
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Button, {
                                type: "button",
                                className: btnempstatus == "2" ? "btn-category px-4 active" : "btn-category px-4",
                                onClick: function() {
                                    setBtnempstatus("2");
                                },
                                children: [
                                    "รอเชื่อมต่อ(",
                                    pesStatusCount["2"],
                                    ")"
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Button, {
                                type: "button",
                                className: btnempstatus == "3" ? "btn-category px-4 active" : "btn-category px-4",
                                onClick: function() {
                                    setBtnempstatus("3");
                                },
                                children: [
                                    "เชื่อมต่อสำเร็จ(",
                                    pesStatusCount["3"],
                                    ")"
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Button, {
                                type: "button",
                                className: btnempstatus == "4" ? "btn-category px-4 active" : "btn-category px-4",
                                onClick: function() {
                                    setBtnempstatus("4");
                                },
                                children: [
                                    "เชื่อมต่อบางส่วน(",
                                    pesStatusCount["4"],
                                    ")"
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                type: "button",
                                className: btnempstatus == 5 ? "btn-category px-4 active" : "btn-category px-4",
                                onClick: function() {
                                    setBtnempstatus(5);
                                },
                                children: "ยกเลิก"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "card card-st-2 pagezoom",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "card-body px-0 pt-4 pb-0",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "d-flex align-items-center px-4 mb-3 flex-wrap",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "me-4",
                                    style: {
                                        marginBottom: "12px"
                                    },
                                    children: /*#__PURE__*/ _jsx(DownloadExcel, {
                                        data: data,
                                        filename: "รายชื่อพนักงาน"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "mb-2 me-auto",
                                    style: {
                                        width: "220px"
                                    },
                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "form-st-3  select-st-1  sm pb-1",
                                        children: [
                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                className: "mb-1",
                                                children: "กลุ่มลูกค้า"
                                            }),
                                            /*#__PURE__*/ _jsx(Select, {
                                                as: "select",
                                                name: "",
                                                //   onChange={(e) => {
                                                //     setCustomer(e);
                                                //   }}
                                                className: "w-100 select-st-1",
                                                options: [],
                                                placeholder: "",
                                                value: "",
                                                isDisabled: true
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "me-3 mb-2",
                                    children: /*#__PURE__*/ _jsx("input", {
                                        type: "text",
                                        className: "form-control form-st-4",
                                        placeholder: "ค้นหาเลขที่,ชื่อลูกค้า",
                                        onKeyUp: function(e) {
                                            return setFilterText(e.target.value);
                                        }
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Link, {
                                    to: "/financial-accounting/peak-connection/pes/create",
                                    className: "btn btn btn-st-7 mb-2 px-4",
                                    children: "สร้างเอกสารเชื่อมต่อ"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Box, {
                            sx: {
                                height: "782px",
                                width: "100%"
                            },
                            children: /*#__PURE__*/ _jsx(DataGrid, {
                                loading: isMemoLoading,
                                getRowId: function(row) {
                                    return row.id;
                                },
                                getRowHeight: function() {
                                    return "auto";
                                },
                                rows: data,
                                pagination: true,
                                paginationMode: "server",
                                paginationModel: {
                                    page: pageModel.page - 1,
                                    pageSize: pageModel.pageSize
                                },
                                onPaginationModelChange: function(newPagination) {
                                    setPageModel(function(prev) {
                                        return _object_spread_props(_object_spread({}, prev), {
                                            page: newPagination.page + 1,
                                            pageSize: newPagination.pageSize
                                        });
                                    });
                                    getData({
                                        page: newPagination.page + 1,
                                        limit: newPagination.pageSize,
                                        searchText: filterText || "",
                                        mstNewStatusID: btnempstatus
                                    });
                                },
                                rowsPerPage: pageModel.page,
                                rowCount: pageModel.total,
                                columns: columnsd,
                                pageSizeOptions: pageSizeOptions,
                                checkboxSelection: true,
                                disableRowSelectionOnClick: true,
                                slotProps: {
                                    pagination: {
                                        labelRowsPerPage: "จำนวนรายการต่อหน้า"
                                    }
                                },
                                sx: {
                                    fontFamily: "Sarabun",
                                    fontSize: "18px",
                                    ".MuiDataGrid-columnHeaderTitle": {
                                        fontFamily: "Sarabun",
                                        fontSize: "18px"
                                    }
                                }
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "py-4"
            })
        ]
    });
}
